import { render, staticRenderFns } from "./alarmPushRecord.vue?vue&type=template&id=0894306a&scoped=true"
import script from "./alarmPushRecord.vue?vue&type=script&lang=js"
export * from "./alarmPushRecord.vue?vue&type=script&lang=js"
import style0 from "./alarmPushRecord.vue?vue&type=style&index=0&id=0894306a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0894306a",
  null
  
)

export default component.exports